export default __webpack_public_path__ + "static/media/21.4cb01e42.jpg";